var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"title"},[_vm._v("new album.")]),_c('album-detail-partial',{attrs:{"editMode":_vm.editMode}}),_c('div',{staticClass:"cta-box h-box space-x-2"},[_c('button',{staticClass:"button",attrs:{"type":"button"},on:{"click":_vm.createAlbum}},[_vm._v("create")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }